var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.isMobile)?_c('img',{class:['btn-next',{'logged-in':_vm.isLoggedIn}],attrs:{"alt":"Click button to proceed","src":require("@/assets/front-arrow.png")},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.$emit('clicked')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }